module.exports = __webpack_public_path__ + "static/media/slide_1.bb29d9d2.jpg";